import { render, staticRenderFns } from "./EventsListCalendar.vue?vue&type=template&id=6dde08c5&scoped=true"
import script from "./EventsListCalendar.vue?vue&type=script&lang=js"
export * from "./EventsListCalendar.vue?vue&type=script&lang=js"
import style0 from "./EventsListCalendar.vue?vue&type=style&index=0&id=6dde08c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dde08c5",
  null
  
)

export default component.exports